import { AnnouncementsTotalPerCustomerListModel } from '../models/announcements-total-per-customer-list-model';
import { AnnouncementsTotalsPerCustomerFilter } from '../models/announcements-totals-per-customer-filter';
import { AdminStatsAndReportsModel } from '../models/admin-stats-and-reports-model';
import { UrlConfigContainer } from '../../../core/url-config';
import { AjaxDataServiceService } from '../../../core/ajax-data-service.service';
import { EmptyData } from '../../../core/models/empty-data';
import { Injectable } from '@angular/core';
import { UrlConfigService } from '@hrra/core';
import { SalesReportFilterModel } from '../models/sales-report-filter-model';
import {
  SalesReportModel,
  ProductReportModel,
} from '../models/sales-report-model';
import { SuspendedEmailAddress } from '../models/suspended-email-address';

import { PagingWrapper } from '@admin/core/models/paging-wrapper';
import { CvDatabaseReportFilterModel } from '@admin/stats-and-reports/shared/models/cv-database-report-filter-model';
import { CvDatabaseReportModel } from '../models/cv-database-report-model';
import { UserType } from '../../../shared/models/user-type.enum';
import { CvDatabaseClicksReportModel } from '@admin/stats-and-reports/shared/models/cv-database-clicks-report-model';
import { ServerValidationResult } from '@admin/shared/validation/server-validation-result';
import { MatchingAnnouncementsFilterModel } from '../models/matching-announcements-filter-model';
import { Observable, empty } from 'rxjs';
import {
  AnnouncementMatchingListModel,
  AnnouncementMatchingJobseekerModel,
} from '../models/announcement-matching-list-model';
import { AnnouncementMatchingModel } from '../models/announcement-matching-model';
import { AnnouncementMatchingGenerationResultModel } from '../models/announcement-matching-generation-result-model';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { GenericResult } from '@admin/shared/models/generic-result';

@Injectable()
export class AnnouncementMatchingService {
  public getAnnouncementMatchingList(
    announcementMatchingListId: number
  ): Observable<AnnouncementMatchingListModel> {
    return this.ajax.getData(
      this.urlService.urlConfig.api.data.statsandreports.announcementMatching
        .announcementMatchingList.get,
      { announcementMatchingListId: announcementMatchingListId },
      AnnouncementMatchingListModel
    );
  }

  public approveAnnouncementMatchingJobseeker(
    announcementMatchingJobseeker: AnnouncementMatchingJobseekerModel
  ) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.statsandreports.announcementMatching
        .announcementMatchingJobseeker.approve,
      announcementMatchingJobseeker.toObject(),
      EmptyData
    );
  }

  public listAnnouncementMatching(
    filter: PagingFilter<MatchingAnnouncementsFilterModel>
  ): Observable<PagingWrapper<AnnouncementMatchingModel>> {
    // let url = this.urlService.format(this.urlService.urlConfig.api.data.statsandreports.announcementMatching.announcementMatchingList.list, {announcementId: announcementId});
    let url =
      this.urlService.urlConfig.api.data.statsandreports.announcementMatching
        .announcementMatchingList.list;
    return this.ajax.postDataPaging(
      url,
      filter.toObject(),
      AnnouncementMatchingModel
    );
  }

  public generateMatching(announcementId: number | null, year: number) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.statsandreports.announcementMatching
        .announcementMatchingList.generateMatching,
      { announcementId: announcementId, year: year }
    );
    // let url = this.urlService.urlConfig.api.data.statsandreports.announcementMatching.announcementMatchingList.generateMatching;
    return this.ajax.postData(
      url,
      { announcementId: announcementId, year: year },
      AnnouncementMatchingGenerationResultModel
    );
  }

  public regenerateMatching(announcementId: number, year: number) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.statsandreports.announcementMatching
        .announcementMatchingList.regenerateMatching,
      { announcementId: announcementId, year: year }
    );
    return this.ajax.postData(
      url,
      { announcementId: announcementId, year: year },
      EmptyData
    );
  }

  public approveMatchingList(
    announcementMatchingList: AnnouncementMatchingListModel
  ) {
    let url =
      this.urlService.urlConfig.api.data.statsandreports.announcementMatching
        .announcementMatchingList.approve;
    return this.ajax.postData(
      url,
      {
        AnnouncementMatchingListId:
          announcementMatchingList.announcementMatchingListId,
      },
      EmptyData
    );
  }

  public ExpressApprove(announcementMatchingListId: number) {
    let url =
      this.urlService.urlConfig.api.data.statsandreports.announcementMatching
        .announcementMatchingList.ExpressApprove;
    return this.ajax.postData(
      url,
      { announcementMatchingListId: announcementMatchingListId },
      GenericResult
    );
  }

  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}
}
